/*
 * The Fees Slider allows donors to select the fee percentage they want to apply to their donation.
 */

import AnalyticsEvent from 'Scripts/common/analytics-event';

export default class FeesSlider {
    constructor(opts) {
        this.ui = {
            container: $("#section-fees-slider"),
            slider: $("#fees-slider"),
            amountField: opts.amountField,
            customInput: $("#custom-fee-amount"),
            customTrigger: $(".js-fees-slider-show-custom"),
        }

        this.onSetFeePercentageCallback = opts.onSetFeePercentage;
        this.onSetCustomAmountCallback = opts.onSetCustomAmount;

        // Only run if there's a slider
        this.canRun = this.ui.slider.length == 1;

        // Are we using a custom amount rather than the slider/range?
        this.isCustom = false;

        if(this.canRun) {
            this.feeRange = this.getRange();
            this.bindEvents()
            this.refresh();
        }
    }

    bindEvents() {
        this.ui.slider.on("input", this.onChangeSlider.bind(this));
        this.ui.customTrigger.on("click", this.onShowCustomFee.bind(this));
        this.ui.customInput.on("change keyup", this.onSetCustomAmount.bind(this));
    }

    refresh() {
        if(this.isCustom) {
            this.ui.customInput.trigger('change');
        } else {
            this.ui.slider.trigger('input');
        }
    }

    onChangeSlider() {
        const feeIndex = this.ui.slider.val();
        const feePercentage = this.feeRange[feeIndex]

        console.log("FeesSlider.onChangeSlider", feeIndex, feePercentage);

        // How far along should the tooltip and slider background be?
        this.setCssVariables(feeIndex);

        // Run callback in parent process
        this.onSetFeePercentageCallback?.(feePercentage);
    }

    onShowCustomFee() {
        // A/B/C test running - could be fixed amount or a calculated amount
        const initialValue = this.ui.customInput.data('initialAmount')
            || ((this.ui.amountField?.val() || 0) * (this.ui.customInput.data('initialPerc') || this.feeRange[0]));

        console.log("FeesSlider.onShowCustomFee", initialValue);
        this.isCustom = true;
        this.ui.customInput.val(initialValue.toFixed(2));
        this.ui.customInput.trigger('change');
        this.ui.customInput[0].focus({ preventScroll: true });
        this.ui.customInput[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    onSetCustomAmount() {
        const feeAmount = this.ui.customInput.val();
        console.log("FeesSlider.onSetCustomAmount", feeAmount);

        // Don't trigger if blank
        if(!!feeAmount) {
            this.onSetCustomAmountCallback?.(Number(feeAmount));
        }
    }

    // Convert the pipe-delimited amounts to a list of decimals (e.g. "0.14", not "14%")
    getRange() {
        return this.ui.slider
            .data('values')
            .split("|")
            .map(v => Number(v));
    }

    /*
     * How far along should the tooltip and slider background be?
     * If 5 options, then i0 (first) = 0%; i3 (third/middle) = 50%, i4 (fifth/last) = 100%
     */
    setCssVariables(feeIndex) {
        const feeProgressPercent = (100 * feeIndex / (this.feeRange.length - 1)) + "%";

        this.ui.container
            .css("--fee-percent-bg", feeProgressPercent)
            .css("--fee-tooltip-margin", feeProgressPercent);
    }
}